import { resume, resumeAnchor } from "./resume";

// What searching finds in the resume, on the Mac (Spotlight) and the phone (Search): each entry
// points at its spot in the resume (`anchor`, an element id).
export const RESUME_ITEMS = [
  ...resume.experience.map((job) => ({
    id: resumeAnchor(job.company),
    title: job.company.split(",")[0],
    subtitle: `${job.role}, ${job.dates}`,
    keywords: [job.role, job.company, ...job.points].join(" "),
  })),
  ...resume.projects.map((p) => ({
    id: resumeAnchor(p.name),
    title: p.name.split(" — ")[0],
    subtitle: `${p.name.split(" — ")[1] || "Open-source project"}, ${p.date}`,
    keywords: p.description,
  })),
  ...resume.skills.map((s) => ({
    id: `${resumeAnchor("Technical skills")}-${s.label}`,
    anchor: resumeAnchor("Technical skills"),
    title: s.label,
    subtitle: s.value,
    keywords: `skills ${s.value}`,
  })),
  ...resume.education.map((e) => ({
    id: resumeAnchor(e.school),
    title: e.school,
    subtitle: `${e.degree}, ${e.date}`,
    keywords: "education university degree",
  })),
  ...resume.certifications.map((c) => ({
    id: resumeAnchor(c.name),
    title: c.name,
    subtitle: "Certification",
    keywords: "certification aws",
  })),
].map((item) => ({ anchor: item.id, ...item }));

export const contact = (label) => resume.contacts.find((c) => c.label === label);

// Higher is better: a title that starts with the query beats a word inside it, which beats
// a match only in the details.
export const score = (item, q) => {
  const title = item.title.toLowerCase();
  if (title.startsWith(q)) return 4;
  if (title.split(/[\s,.()/—-]+/).some((w) => w.startsWith(q))) return 3;
  if (title.includes(q)) return 2;
  if (`${item.subtitle || ""} ${item.keywords || ""}`.toLowerCase().includes(q)) return 1;
  return 0;
};

// The `limit` best matches for `q` (lowercase), best first.
export const best = (items, q, limit) =>
  items
    .map((item) => ({ item, s: score(item, q) }))
    .filter((r) => r.s > 0)
    .sort((a, b) => b.s - a.s)
    .slice(0, limit)
    .map((r) => r.item);

// Search results in sections, with the single best match pulled out first as the Top Hit when
// it's a strong one (its title starts with, or has a word starting with, the query).
export const withTopHit = (groups, q) => {
  const top = groups
    .flatMap((g) => g.items)
    .map((item) => ({ item, s: score(item, q) }))
    .sort((a, b) => b.s - a.s)[0];
  const rest = groups.map((g) => ({ ...g, items: top && top.s >= 3 ? g.items.filter((i) => i !== top.item) : g.items }));
  if (top && top.s >= 3) rest.unshift({ title: "Top Hit", items: [top.item], top: true });
  return rest.filter((g) => g.items.length);
};
